import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  spreadSheetTable: {
    '& .Spreadsheet__cell, & .Spreadsheet__header': {
      '&:nth-child(2)': {
        width: '70%'
      },
      '&:nth-child(3)': {
        width: '30%'
      }
    }
  }
})

export default useStyles
